import React from "react";
import { PhotoSessionStates } from "../../../config/PhotoConfigs.js";

const PhotoUploadSessionContext = React.createContext({
  state: PhotoSessionStates.IDLE,
  raceId: null,
  items: [],
  folderTagsByPath: {},
  sessionTags: [],
  currentFilename: "",
  uploadedCount: 0,
  totalCount: 0,
  loadReview: () => {},
  startUpload: () => {},
  cancelUpload: () => {},
  retryFailed: () => {},
  clearSession: () => {},
  setFolderTags: () => {},
  setFileTags: () => {},
  setSessionTags: () => {},
});

export default PhotoUploadSessionContext;
